import React, { useEffect, useMemo, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Box, Alert, useMediaQuery } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import AdminSidebar, { SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED } from "./AdminSidebar";
import { isPlatformAdmin } from "./adminUtils";

const AdminLayout = () => {
    const { userRole, logout } = useAuth();
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width: 768px)");
    const [sidebarOpen, setSidebarOpen] = useState(true);

    const adminAccess = useMemo(() => isPlatformAdmin(userRole), [userRole]);
    const isCollapsed = isMobile ? false : !sidebarOpen;

    useEffect(() => {
        if (!adminAccess) {
            navigate("/");
        }
    }, [adminAccess, navigate]);

    if (!adminAccess) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="error">
                    Access denied. This portal is only available to users with the ADMIN#VI295 role.
                </Alert>
            </Box>
        );
    }

    return (
        <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#F7F9FC" }}>
            <AdminSidebar
                isCollapsed={isCollapsed}
                onToggle={() => setSidebarOpen((prev) => !prev)}
                onLogout={logout}
                isMobile={isMobile}
            />
            <Box
                component="main"
                sx={{
                    flex: 1,
                    minWidth: 0,
                    minHeight: "100vh",
                    overflow: "auto",
                    transition: "margin-left 250ms ease",
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
};

export default AdminLayout;
export { SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED };
